import React, { useState } from "react";
import { Card, CardBody, Button } from "reactstrap";
import axiosInstance from "../../request";
import { URL } from "../../api";

const OverallCollectionReporting = () => {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(URL.OVERALL_COLECTION_REPORT, {
        params: { export: true },
        responseType: "blob",
      });

      const blob = new Blob([response.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Overall_Collection_Report_${new Date().toISOString().split("T")[0]}.csv`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      alert("Export failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="shadow-sm border-0 mt-3">
      <CardBody className="d-flex flex-column align-items-start gap-3">
        <h5 className="text-muted mb-2">Overall Collection Report</h5>
        <Button color="success" onClick={handleExport} disabled={loading}>
          {loading ? (
            <>
              <i className="fas fa-spinner fa-spin me-2"></i>Exporting...
            </>
          ) : (
            <>
              <i className="fas fa-file-excel me-2"></i>Export Report
            </>
          )}
        </Button>
      </CardBody>
    </Card>
  );
};

export default OverallCollectionReporting;
